import { render, staticRenderFns } from "./NotificaNotaCredito.vue?vue&type=template&id=923f5412&"
import script from "./NotificaNotaCredito.vue?vue&type=script&lang=js&"
export * from "./NotificaNotaCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports